import { ServiceMaker, methods, services } from '@/services';

export const deliverySetuplist = () => ServiceMaker(`/freight/api/v1/shipping/charge-matrixs`, methods.GET, services.master);

export const createDeliverySetup = (payload) => ServiceMaker(`/freight/api/v1/shipping/charge-matrix/create`, methods.POST, services.master,payload);

export const updateDeliverySetup = (id,data) => ServiceMaker(`/freight/api/v1/shipping/charge-matrix/${id}`, methods.PUT, services.master, data);

export const deleteDeliverySetup = (id) => ServiceMaker(`/freight/api/v1/shipping/charge-matrix/${id}`, methods.DELETE, services.master)

export const deliverySetuplistbyID = (id) => ServiceMaker(`/freight/api/v1/shipping/charge-matrix/${id}`, methods.GET, services.master)


